import * as React from "react";
import { Input } from "./Input";
import { extendFormGroupProps } from "./use-form-group";
export function DateTimeOffsetInput(props) {
    props = extendFormGroupProps(props);
    let type = props.type || 'datetime-local';
    let value = React.useMemo(() => {
        var val = props.value;
        if (type == 'date') {
            if (val) {
                return val.substr(0, Math.min(10, val.length));
            }
        }
        else if (type == 'datetime-local') {
            if (val) {
                return val.substr(0, Math.min(16, val.length));
            }
        }
        return val;
    }, [type, props.value]);
    let handleChange = React.useMemo(() => {
        return (evt) => {
            let nextVal = evt.target.value;
            if (nextVal) {
                var dashIdx = nextVal.indexOf("-");
                var year = nextVal.substr(0, dashIdx);
                nextVal =
                    year.substr(Math.max(0, year.length - 4)) +
                        nextVal.substr(dashIdx);
                if (nextVal.length < 11) {
                    nextVal += "T00:00:00";
                }
                else if (nextVal.length < 17) {
                    nextVal += ":00";
                }
                nextVal += new Date().hokToISOTimezoneOffsetString();
            }
            props.onChange({ target: { value: nextVal, name: evt.target.name } });
        };
    }, [type, props.onChange]);
    //ChangeEventInput
    return React.createElement(Input, Object.assign({}, props, { value: value, onChange: handleChange }));
}
//# sourceMappingURL=DateTimeOffsetInput.js.map